import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const MoreButtonComponent = ({ onClick, children, disabled, hidden }) => {
  if (hidden) return null;
  return (
    <TooltipComponent content="More" id="more-tooltip" placement="bottom">
      <ButtonComponent type="button" color="info mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="mdi:read-more-outline" height="18" color = "black" /> &nbsp;&nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

MoreButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
}

export default MoreButtonComponent
